import { render, staticRenderFns } from "./AdhocRecognition.vue?vue&type=template&id=3feafc91&"
import script from "./AdhocRecognition.vue?vue&type=script&lang=js&"
export * from "./AdhocRecognition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports